import {WPCheckItemValue} from "./WPCheckItemValue";

export interface WPCheckItem {
  // DB Vaule
  uid: number;
  companyUID: number; // 업체 UID
  categoryIndex: number; // 카테고리 인덱스  0 - 일반작업, 1 - 화기작업, 2 - 밀페작업, 3 - 정전작업, 4 - 굴착작업, 5 - 방사선, 6 - 고소작업, 7 - 중장비
  name: string; // 항목 명
  displayOrder: number; // 표시 순서
  isDeleted: boolean;

  // Not DB
  itemValue: WPCheckItemValue; // 항목의 체크 값
}

export const initializeCheckItem = (): WPCheckItem => {
  return {
    uid: 0,
    companyUID: 0, // 업체 UID
    categoryIndex: 0, // 카테고리 인덱스  0 - 일반작업, 1 - 화기작업, 2 - 밀페작업, 3 - 정전작업, 4 - 굴착작업, 5 - 방사선, 6 - 고소작업, 7 - 중장비
    name: "", // 항목 명
    displayOrder: 0, // 표시 순서
    isDeleted: false,

    // Not DB
    itemValue: {} as WPCheckItemValue, // 항목의 체크 값
  };
};

export interface CheckItemParams {
  token: string; // 사용자 토큰
  categoryIndex: number; // 해당 카테고리 인덱스 번호
}

export const InitialCheckItemParams = {
  token: "", // 사용자 토큰
  categoryIndex: 0, // 해당 카테고리 인덱스 번호
};
